import { render, staticRenderFns } from "./Koutu_Step_PixelPeeler.vue?vue&type=template&id=5b13c74a&scoped=true"
import script from "./Koutu_Step_PixelPeeler.vue?vue&type=script&lang=js"
export * from "./Koutu_Step_PixelPeeler.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Step_PixelPeeler.vue?vue&type=style&index=0&id=5b13c74a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13c74a",
  null
  
)

export default component.exports